import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import Select from '../common/form/select';

import { setModoTela, initForm } from './usuarioActions';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';

class UsuarioForm extends Component {

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome *' placeholder='Informe o Nome'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='login'
								component={LabelAndInput}
								label='Login *'
								placeholder='Informe o Usuário'
								cols='12 12 12 12'
								readOnly={readOnly} />

							{!this.props.configuracao && (
								<Field
									name='senha'
									component={LabelAndInput}
									type="password"
									label='Senha *'
									placeholder='Informe a Senha'
									cols='12 12 12 12'
									readOnly={readOnly} />
							)}

							<Field
								name='id_perfil'
								component={Select}
								options={this.props.listaPerfil}
								label='Perfil'
								cols='12 12 12 12'
								placeholder='Selecione o perfil'
								readOnly={readOnly} />

							<Field
								name='id_unidade'
								component={Select}
								options={this.props.listaUnidade}
								label='Base Responsável'
								cols='12 12 12 12'
								placeholder='Selecione a base'
								readOnly={readOnly} />
								
							{this.props.configuracao && (
								<Field
									name='codigo'
									component={LabelAndInput}
									label='Código Representante'
									placeholder='Informe o código'
									cols='12 12 12 12'
									readOnly={readOnly} />
							)}
							
							{this.props.configuracao && (
								<Field
									name='codigo_substituto'
									component={LabelAndInput}
									label='Código Representante Substituto'
									placeholder='Informe o código'
									cols='12 12 12 12'
									readOnly={readOnly} />
							)}

							{this.props.configuracao && (
								<Field
									name='whatsapp'
									component={LabelAndInputMask}
									label='Whatsapp'
									placeholder='Informe o número'
									cols='12 6 4 3'
									readOnly={readOnly}
									mask='(99) 9 9999-9999' />
							)}

							{(this.props.configuracao || !this.props.formularioValues.id) &&
							<Select
								name='ids_gestao_veiculo_operacao'
								label='Gestão - Operações dos Veículos' placeholder='Informe as operações'
								cols='12 12 12 12'
								multiple
								readOnly={readOnly}
								options={this.props.listaOperacao}
								value={this.props.listaOperacao.map(item => ({ value: item.id, label: item.valor })).filter(item => (this.props.formularioValues.ids_gestao_veiculo_operacao || []).includes(item.value))}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										ids_gestao_veiculo_operacao: value.map(item => item.value)
									});
								}} />}

							{(this.props.configuracao || !this.props.formularioValues.id) &&
							<Select
								name='ids_gestao_unidade'
								label='Gestão - Bases' placeholder='Informe as bases'
								cols='12 12 12 12'
								multiple
								readOnly={readOnly}
								options={this.props.listaUnidade}
								value={this.props.listaUnidade.map(item => ({ value: item.id, label: item.valor })).filter(item => (this.props.formularioValues.ids_gestao_unidade || []).includes(item.value))}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										ids_gestao_unidade: value.map(item => item.value)
									});
								}} />}

							<br />
							{(this.props.configuracao || !this.props.formularioValues.id) &&
							<Field
								name='bloqueia_base'
								component={LabelAndCheckbox}
								label='Permite bloquear base'
								placeholder='Informe'
								cols='12 12 12 12 '
								readOnly={readOnly} />}

						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

UsuarioForm = reduxForm({form: 'usuarioForm', destroyOnUnmount: false})(UsuarioForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('usuarioForm')(state),
	registro: state.usuario.registro,
	listaPerfil: state.usuario.listaPerfil,
	listaUnidade: state.usuario.listaUnidade,
	listaOperacao: state.usuario.listaOperacao
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(UsuarioForm);
